<template>
  <div class="rate">
    <div class="content">
      <div class="left">
        <img :src="findDetail.headImgUuid" alt="">
        <div class="info">
          <p class="name">{{findDetail.name}}</p>
          <p class="tel">{{findDetail.mobile}}</p>
          <p class="code">工牌号：{{findDetail.workId}}</p>
        </div>
      </div>
      <div class="right">
        <div class="tag_list">
            <div class="tag_item" v-for="(item,index) in tagList" :key="index"  >
             <el-tag @click="setTag(index,item)"   :type="item.isPick ? 'success' : 'info'">{{item.name}}</el-tag>
        </div>
        </div>
        <el-rate v-model="info.evaluateStar"  @change="handleChange"></el-rate>
        <!--<ul class="list">-->
          <!--<li v-for="(item, index) in type" :key="index">{{item}}</li>-->
        <!--</ul>-->
        <textarea name="" id="" cols="30" rows="10" placeholder="可以填写您对跑腿员的匿名反馈 " v-model="info.evaluateContent"></textarea>
        <button @click="pull">提交</button>
      </div>
    </div>
  </div>
</template>

<script>
import {reqEvaluate, reqFindDetail,reqBankList} from '../../api'
export default {
  props: ['orderNum'],
  data () {
    return {
      tagList:[],
      info: {
        evaluateContent: '',
        evaluateStar: null,
        orderId: this.orderNum
      },
      findDetail: {},
      value: null,
      type: ['取件时间长', '送件时间长', '服务不规范', '衣冠不整', '态度恶劣', '物品损坏']
    }
  },
  created() {
    console.log(this.orderNum);
     reqBankList('badLabel').then(res=>{
        console.log('标签列表',res)
        res.data.bussData.forEach(item=>{
          item.isPick=false
        })
        this.tagList=res.data.bussData


      })
    reqFindDetail(this.orderNum).then(res => {
      console.log(res);
      if(res.code === 200) {
        this.findDetail = res.data.bussData
      }
    })
  },
  methods: {
    setTag(index,item){
      // 选中标签
      this.tagList[index].isPick=!this.tagList[index].isPick
    },
    // 星星的改变
    handleChange(val) {
      this.info.evaluateStar = val
    },
    // 提交
    pull() {

      // 选中标签拼接 
      // this.info.evaluateContent
      this.tagList.forEach(item=>{
        if(item.isPick){
          this.info.evaluateContent= item.name+ ','+this.info.evaluateContent
        }
      })
      if(!this.info.evaluateStar) {
        this.$message({
          message: '请选择评论级别',
          type: 'error'
        })
      } else {
        reqEvaluate(this.info).then(res => {
          console.log(res)
          if(res.code === 200) {
            this.$message({
              message: '评论成功',
              type: 'success'
            })
            this.$emit('closeRate')
          }
        })
      }
    }
  }
}
</script>

<style lang="less" type="text/less">
.tag_list{
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  // margin: 0px;
  .tag_item{
    margin: 5px 5px;
    cursor: pointer;
  }
}
  .rate{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.5);
    .content{
      display: flex;
      width: 735px;
      height: 600px;
      margin:100px auto 0;
      padding:25px 36px 32px 27px;
      background: #fff;
      border-radius:10px;
      box-sizing: border-box;
      .left{
        border:10px solid #f1f1f1;
        margin-right: 30px;
        img{
          display: block;
          width: 202px;
          height: 245px;
          background: #eee;
        }
        .info{
          text-align: center;
          .name{
            font-size: 18px;
            color:#000;
            margin-top:25px;
          }
          .tel, .code{
            margin-top:15px;
          }
        }
      }
      .right{
        .list{
          display: flex;
          flex-wrap: wrap;
          margin-top:27px;
          li{
            width: 120px;
            height: 36px;
            margin-right: 30px;
            margin-bottom: 20px;
            text-align: center;
            line-height: 36px;
            border:1px solid #e1e1e1;
            border-radius: 18px;
            box-sizing: border-box;
            cursor: pointer;
            color:#000;
            &:nth-of-type(3n){
              margin-right: 0;
            }
          }

        }
        textarea{
          width: 418px;
          height: 114px;
          margin-top:10px;
          padding:10px;
          background: #f8f8f8;
          border:none;
          resize: none;
        }
        button{
          display: block;
          width:332px;
          height:48px;
          margin:28px auto 0;
          border:none;
          font-size: 18px;
          font-weight: bold;
          color:#fff;
          background:#61aee6;
          box-shadow:0px 5px 9px 0px rgba(0, 0, 0, 0.15);
          border-radius:24px;
        }
      }
    }
    .el-rate{
      height: 32px;
    }
    .el-rate__icon{
      font-size: 32px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Person/Rate.vue